<template>
    <div id="viewDiv">
        <div v-if="mapConfig.showToolbar" id="toolbar">
            <button class="action-button esri-icon-checkbox-unchecked" id="rectangleButton" type="button"
                title="Select features"></button>
            <button :class="{'action-button': true, 'esri-icon-collection': true, 'action-button-toggle': multiSelect}" id="multiselectButton" type="button"
                title="Toggle Multi-Select"></button>
            <button class="action-button esri-icon-close" id="clearButton" type="button" title="Clear selection"></button>
        </div>
    </div>
</template>
<script>
    import axios from 'axios'
    import { loadModules } from 'esri-loader';

    export default {
        props: [
            'checkedLayers', 'selectedFeature', 'configName', 'updateFeature', 'selectionData', 'updateLayer', 
            'domains', 'configReady', 'mapConfig', 'searchValue', 'customQuery', 'resetView', 'externalData'
        ],
        methods: {
            setData(feature, field, type) {
                let data = "";
                
                if (Array.isArray(field)) {
                    for (let i = 0; i < field.length; i++)
                        data += `${feature.attributes[field[i]]} `;
                    data = data.trim();
                } // if
                else if (type == "date")
                    data = new Date(feature.attributes[field]).toISOString().split('T')[0];
                else if (feature.attributes[field] === 0 || feature.attributes[field])
                    data = feature.attributes[field];

                return data;
            },
            setResult(feature) {
                let result = {val:[]};
                let objectidField = this.getObjectidField(feature);

                result.objectid = feature.attributes[objectidField];
                result.layerName = feature.attributes.layerId;

                if (this.mapConfig.resultMap[result.layerName]) {
                    let map = this.mapConfig.resultMap[result.layerName];
                    for (let i = 0; i < map.length; i++) {
                        let obj = map[i].value;
                        
                        obj.data = this.setData(feature, map[i].dataField, map[i].type);
                        result.val.push(obj);
                    } // for
                } // if

                return result;
            },
            selectedFeatureChange (newVal, oldVal) {
                if (newVal) {
                    this.highlightFeature(newVal);
                    this.$emit('mapclick-complete', this.setResult(newVal));
                } // if
            },
            addFeatures(features) {
                features.push(...this.map.findLayerById("resultLayer").graphics.items);
                this.map.findLayerById("resultLayer").graphics.removeAll();

                for (let i = 0; i < features.length; i++)
                {
                    if (features[i].geometry.type === "point")
                        features[i].symbol = {
                            type: "simple-marker",
                            color: [255,0,255,0.4],
                            width: 4
                        };
                    else
                        features[i].symbol = {
                            type: "simple-line",  // autocasts as SimpleLineSymbol()
                            color: [255,0,255], // Color for search selections
                            width: 4
                        };
                    if (features[i].layer && !features[i].attributes.layerId)
                        features[i].attributes.layerId = features[i].layer.id;
                    if (this.mapConfig.externalDataMap[features[i].attributes.layerId]) {
                        let dataMap = this.mapConfig.externalDataMap[features[i].attributes.layerId];
                        
                        for (let extIdx = 0; extIdx < this.externalData.length; extIdx++) {
                            if (this.externalData[extIdx][dataMap.primaryField] === features[i].attributes.ID.toString()) {
                                for (let field in dataMap.fields) {
                                    features[i].attributes[field] = this.externalData[extIdx][dataMap.fields[field]];
                                } // for
                            } // if
                        } // for
                    } // if
                    features[i].popupTemplate = this.mapConfig.templates[features[i].attributes.layerId];
                    this.map.findLayerById("resultLayer").add(features[i]);
                    // this.view.popup.viewModel.features = this.map.findLayerById("resultLayer").graphics;
                } // for
                
                if (features.length > 0) {
                    this.highlightFeature(features[0]);
                    if (features[0].popupTemplate) {
                        this.view.popup.viewModel.features = features;
                        this.view.popup.set("visible", true);
                    } // if
                    //this.$emit('mapclick-complete', this.setResult(features[0]));
                } // if
            },
            highlightFeature(feature) {
                let layer = this.map.findLayerById("highlightLayer");
                let newFeature = feature.clone();
                
                if (newFeature.geometry.type === "point") {
                    this.view.popup.viewModel.location = newFeature.geometry;
                    newFeature.symbol = {
                        type: "simple-marker",  // autocasts as SimpleLineSymbol()
                        color: [255,255,32,0.4], // Color for search selections
                        width: 4
                    };
                } // if
                else {
                    this.view.popup.viewModel.location = newFeature.geometry.extent.center;
                    newFeature.symbol = {
                        type: "simple-line",  // autocasts as SimpleLineSymbol()
                        color: [255,255,32], // Color for search selections
                        width: 4
                    };
                } // else

                layer.removeAll();
                layer.add(newFeature);
                
                this.view.goTo({ target: newFeature, scale: this.mapConfig.highlightScale }, {animate: true});
            },
            async layerQuery(layer, query) {
                let queryData;

                try {
                    queryData = await layer.queryFeatures(query).catch( err => { throw err });
                    return queryData.features;
                } 
                catch (err) {
                    console.log(err);
                }

                return [];
            },
            async queryVisibleLayers(query) {
                let index = 0;
                let results = [];
                let currLayer;
                let type = "";

                for (index = 0; index < this.checkedLayers.length; index++) {
                    //if (this.mapConfig.layerDefs[this.checkedLayers[index]].selectable) {
                    if (this.mapConfig.layerDefs[this.checkedLayers[index]][query.xType]) {
                        currLayer = this.map.findLayerById(this.checkedLayers[index]);
                        results = results.concat(await this.layerQuery(currLayer, query));
                    } //if
                } // for

                return results;
            },
            async queryLayer(query, layer) {
                let results = [];
                let currLayer;

                currLayer = this.map.findLayerById(layer);
                results = await this.layerQuery(currLayer, query);
                
                return results;
            },
            async findFeatures(query, layer) {
                let results;
                
                if (layer)
                    results = await this.queryLayer(query, layer);
                else
                    results = await this.queryVisibleLayers(query);
                    
                if (!this.multiSelect) {
                    this.searchClear();
                } //if
                this.addFeatures(results);
            },
            mapClick(evt) {
                if (evt.type = "click") {
                    let query = {
                        units: "meters",
                        distance: "20",
                        geometry: evt.mapPoint,
                        outFields: ["*"],
                        returnGeometry: true,
                        xType: "selectable"
                    };

                    this.findFeatures(query);
                } // if
            },
            selectFeatures(event) {
                let query = {
                    geometry: event.geometry,
                    outFields: ["*"],
                    returnGeometry: true,
                    xType: "selectable"
                };

                this.findFeatures(query);
            },
            async querySearchLayers(query) {
                let results = [];
                let currLayer;

                for (let layerName in this.mapConfig.searchMap.layers) {
                    currLayer = this.map.findLayerById(layerName);
                    results = results.concat(await this.layerQuery(currLayer, query));
                } // for

                return results;
            },
            async searchComplete(evt) {
                if (evt.results.length > 0 && evt.results[0].results.length > 0) {
                    let match = evt.results[0].results[0];
                    let query = {
                        units: "meters",
                        distance: "100",
                        geometry: match.feature.geometry,
                        outFields: ["*"],
                        returnGeometry: true,
                        xType: "searchable"
                    };

                    let findResults = await this.querySearchLayers(query);
                    this.searchClear();
                    match.feature.attributes = this.processSearchAttributes(match,findResults);
                    if (this.mapConfig.searchMap.allResults)
                        findResults.unshift(match.feature);
                    else
                        findResults = [match.feature];
                    this.addFeatures(findResults);
                    this.$emit('search-complete', match.feature.attributes);
                } // if
            },
            processSearchAttributes(match, results)
            {
                let attributes = {
                    layerId: this.mapConfig.searchMap.layerId
                };
                let set = {};

                attributes[this.mapConfig.searchMap.name] = match.name;
                
                for (let i = 0; i < results.length; i++)
                {
                    let layerId = results[i].layer.id;
                    let attribs = this.mapConfig.searchMap.layers[layerId];

                    if (attribs.type == "contains")
                        set[layerId] = results[i].geometry.extent.contains(match.extent.center);
                    else if (attribs.type == "closest" && !set[layerId])
                        set[layerId] = true;
                    else
                        set[layerId] = false;
                    
                    if (set[layerId]) {
                        for (let j = 0; j < attribs.fields.length; j++) {
                            if (typeof attribs.fields[j] === "object") {
                                switch (attribs.fields[j].type) {
                                    case "date":
                                        attributes[attribs.fields[j].field] = new Date(results[i].attributes[attribs.fields[j].field]).toISOString().split('T')[0];
                                        break;
                                    default:
                                        break;
                                } // switch
                            } //if
                            else if (this.domains[attribs.fields[j]])
                                attributes[attribs.fields[j]] = this.domains[attribs.fields[j]][results[i].attributes[attribs.fields[j]]];
                            else
                                attributes[attribs.fields[j]] = results[i].attributes[attribs.fields[j]];
                        } // for
                    } // if
                } // for

                return attributes;
            },
            searchClear(event) {
                this.map.findLayerById("resultLayer").removeAll();
                this.map.findLayerById("highlightLayer").removeAll();
                this.view.popup.set("visible", false);
                this.$emit('search-clear');
            },
            async runCustomQuery(val) {
                if (val > -1 && val < this.mapConfig.customQueries.length) {
                    let query = {
                        where: this.mapConfig.customQueries[val].where,
                        outFields: ["*"],
                        returnGeometry: true,
                        outSpatialReference: this.view.spatialReference
                    };

                    await this.findFeatures(query, this.mapConfig.customQueries[val].layer);
                    
                    this.$emit('custom-query-complete');
                } // if
            },
            credCreate(event) {
                this.$emit('cred-create', { token: event.credential.token, user: event.credential.userId, url: event.credential.resources[0] });
            },            
            setVisibility(visible, layers)
            {
                //***FIX*** THIS GRABS THE SAME map-image LAYER MULTIPLE TIMES
                for (let i = 0; i < layers.length; i++)
                {
                    let layer = this.getLayer(this.mapConfig.layerDefs[layers[i]].layerName);
                    if (layer.type === "map-image") {
                        if (layer.sublayers.length > 0) {
                            this.getSublayer(layer, this.mapConfig.layerDefs[layers[i]].subindex).visible = visible;
                        } //if
                    } //if
                    else {
                        layer.visible = visible;
                    } //else
                } //for
            },
            setLayers(val, oldVal) {
                if (this.map) {
                    if (!oldVal)
                        oldVal = [];
                    if (!val)
                        val = [];
                    
                    let hideLayers = oldVal.filter(e => !val.indexOf(e) > -1);
                    let showLayers = val.filter(e => !oldVal.indexOf(e) > -1);
                    
                    this.setVisibility(false, hideLayers);
                    this.setVisibility(true, showLayers);
                } // if
            },
            async applyEdits(edits, layerName) {
                let updateResult = await this.map.findLayerById(layerName).applyEdits(edits);
                this.$emit('feature-update-complete');
                //this.view.popup.set("visible", false);

                //Refresh the appropriate map-image layer to display changes
                this.map.findLayerById(this.mapConfig.layerDefs[layerName].layerName).refresh();
            },
            processEdits(data, features) {
                let linkedLayer = this.mapConfig.layerDefs[data.layerName].linkedLayer;
                let edits = {
                    "updateFeatures" : []
                };
                let objectidField;

                for (var i = 0; i < features.length; i++) {
                    objectidField = this.getObjectidField(features[i]);
                    edits.updateFeatures.push({  "attributes" : {} });
                    edits.updateFeatures[i].attributes[objectidField] = features[i].attributes[objectidField];

                    for (let j = 0; j < data.val.length; j++)
                    {
                        if (data.val[j].field) {
                            edits.updateFeatures[i].attributes[data.val[j].field] = data.val[j].data;
                            if (linkedLayer && data.val[j].field == linkedLayer.field.from) {
                                this.linkedLayerUpdate(linkedLayer, data.val[j].data, features[i].geometry);
                            } // if
                        } // if
                    } // for
                } // for
                this.applyEdits(edits, data.layerName);
            },
            featureUpdate(val, oldVal) {
                if (oldVal == 0 && val != oldVal) {
                    let features = [];
                    
                    if (val == 1) {
                        features.push(this.map.findLayerById('resultLayer').graphics.items[this.view.popup.selectedFeatureIndex]);
                    } // if
                    else if (val == 2) {
                        features = this.map.findLayerById('resultLayer').graphics.items;
                    } // else if

                    this.processEdits(this.selectionData, features);
                } // else if
            },
            async fullLayerUpdate(data) {
                let query = {
                    where : '1 = 1',
                    outFields : ["*"],
                    returnGeometry : true
                };
                let features = await this.layerQuery(this.map.findLayerById(data.layerName), query);
                let processData = {
                    layerName : data.layerName,
                    val : [ {field : data.field, data : data.value }]
                };

                this.processEdits(processData, features);
            },
            async linkedLayerUpdate(linkedLayer, value, geometry) {
                let query = {
                    geometry: geometry,
                    outFields: ["*"],
                    returnGeometry: true
                };
                const { features } = await this.map.findLayerById(linkedLayer.name).queryFeatures(query).catch( err => { throw err });                

                if (linkedLayer.field.map)
                    value = linkedLayer.field.map[value];

                let processData = {
                    layerName : linkedLayer.name,
                    val : [ {field : linkedLayer.field.to, data : value }]
                };

                this.processEdits(processData, features);
            },
            async tableSelect(val, oldVal) {
                if (this.map) {
                    let layerName;
                    let query = {
                        outFields: ["*"],
                        returnGeometry: true,
                        outSpatialReference: this.view.spatialReference
                    };
    
                    layerName = val.layerId;
                    query.where = `${val.field} = ${val.value}`;
    
                    let results = [];
                    let currLayer = this.map.findLayerById(layerName);
                    let selectedFeatures;
    
                    try {
                        let { features } = await currLayer.queryFeatures(query).catch( err => { throw err });
                        selectedFeatures = features;
                    } catch (err) {
                        console.log(err);
                    }
                    
                    this.searchClear();
    
                    this.addFeatures(selectedFeatures);
                } // if
            },
            getObjectidField(feature) {
                let fieldNames = ["OBJECTID", "OBJECTID_1", "OBJECTID_12"];

                for (let i = 0; i < fieldNames.length; i++)
                {
                    if (feature.attributes[fieldNames[i]])
                        return fieldNames[i];
                } // for

                return null;
            },
            getLayer(layerName) {
                return this.map.findLayerById(layerName);
            },
            getSublayer(layer, subindex) {
                return layer.sublayers.items[subindex];
            },
            addLiveMarkers(data) {
                let size;
                let style;
                let units = {};
                let unitIndex = 0;
                let i;
                let colors = [[0, 192, 192],  [192, 192, 192], [224, 224, 0]];
                let layer = this.map.findLayerById("liveLayer");
                let bucketField = this.mapConfig.liveBucketField;
                layer.removeAll();

                // Split units into buckets
                for (i = 0; i < data.length; i++)
                {
                    if (units[data[i][bucketField]]) {
                        units[data[i][bucketField]].push({X: data[i].X, Y: data[i].Y});
                    }
                    else {
                        units[data[i][bucketField]] = [ {X: data[i].X, Y: data[i].Y} ];
                    } // else
                } // for

                //Add breadcrumb and head marker for each unit
                for (let unit in units)
                {
                    for (i = 0; i < units[unit].length; i++) {
                        if (i == units[unit].length - 1)
                        {
                            console.log("Diamond");
                            size = 12; //Make the symbol bigger for the head
                            style = "diamond";
                        } // if
                        else {
                            size = 4;
                            style = "circle";
                        } // else

                        layer.add({
                            geometry: {x: units[unit][i].X, y: units[unit][i].Y, type: "point"},
                            symbol: {
                                type: "simple-marker",  // autocasts as new SimpleMarkerSymbol()
                                style: style,
                                //color: "blue",
                                color: colors[unitIndex%colors.length],
                                size: size,
                                outline: {  // autocasts as new SimpleLineSymbol()
                                    width: 0.6,
                                    //color: "darkblue"
                                    color: "black"
                                }
                            }
                        });
                    }
                    unitIndex++;
                } // for...in
            }, // addLiveMarkers()
            runSearch(val, oldVal) {
                if (val !== "") {
                    // do search with val
                    this.search.searchTerm = val;
                    this.search.search();
                } // if
            },
            defaultView(val) {
                if (val) {
                    this.view.center = [this.mapConfig.view.center.x, this.mapConfig.view.center.y];
                    this.view.zoom = this.mapConfig.view.zoom;
                    this.searchClear();
                    this.$emit('reset-complete');
                } // if
            },
            async loadMap() {
                console.log("Load map...");

                 // first, we use Dojo's loader to require the map class
                const [MapView, EsriMap, Graphic, IdentityManager, FeatureLayer, GraphicsLayer, MapImageLayer, Legend, Search, Expand,
                    Locator, SketchViewModel, IdentifyTask, QueryTask, IdentifyParameters, IdentifyResult, Query] = 
                await loadModules([
                    'esri/views/MapView',
                    'esri/Map',
                    'esri/Graphic',
                    'esri/identity/IdentityManager',
                    'esri/layers/FeatureLayer',
                    'esri/layers/GraphicsLayer',
                    'esri/layers/MapImageLayer',
                    'esri/widgets/Legend',
                    'esri/widgets/Search',
                    'esri/widgets/Expand',
                    'esri/tasks/Locator',
                    'esri/widgets/Sketch/SketchViewModel',
                    'esri/tasks/IdentifyTask',
                    'esri/tasks/QueryTask',
                    'esri/tasks/support/IdentifyParameters',
                    'esri/tasks/support/IdentifyResult',
                    'esri/tasks/support/Query'
                ]).catch(err => { console.error(err); });

                this.map  = new EsriMap({
                    basemap: this.mapConfig.basemap/*,
                    ground: "world-elevation"*/
                });

                for (let i = 0; i < this.mapConfig.layers.length; i++)
                {
                    let layer;

                    if (this.mapConfig.layers[i].type === "map-image") {
                        layer = new MapImageLayer(this.mapConfig.layers[i].data);
                        this.map.add(layer);
                    }
                    else
                        this.map.add(new FeatureLayer(this.mapConfig.layers[i].data));
                } //for
                this.map.add(new GraphicsLayer({
                    outFields: ["*"],
                    visible: true,
                    opacity: 0.9,
                    id: "resultLayer"
                }));
                this.map.add(new GraphicsLayer({
                    outFields: ["*"],
                    visible: true,
                    opacity: 0.9,
                    id: "highlightLayer"
                }));

                this.map.add(new GraphicsLayer({
                    outFields: ["*"],
                    visible: true,
                    opacity: 0.9,
                    id: "liveLayer"
                }));

                this.identifyTask = new IdentifyTask(this.mapConfig.identifyTask);

                this.identifyParams = new IdentifyParameters(this.mapConfig.identifyParams);

                this.queryTask = new QueryTask(this.mapConfig.queryTask);

                this.query = new Query(this.mapConfig.query);

                IdentityManager.on("credential-create", this.credCreate);

                
                    
                //Set currently checkedLayers and remove previously checked layers
                this.setLayers(this.checkedLayers);

                this.view = new MapView({
                    map: this.map,
                    container: 'viewDiv',
                    center: this.mapConfig.map.position,
                    zoom: this.mapConfig.map.zoom
                });

                if (this.mapConfig.legend) {
                    this.legend = new Legend({
                        view : this.view,
                        style : "classic"
                    });
                    // this.view.ui.add(this.legend, "bottom-right");

                    let legendExpand = new Expand({
                        expandIconClass: "esri-icon-navigation",
                        expandTooltip: "Show Legend",
                        collapseTooltip: "Hide Legend",
                        view: this.view,
                        content: this.legend
                    });
                    this.view.ui.add(legendExpand, "bottom-right");
                } // if

                if (this.mapConfig.search) {
                    this.search = new Search({
                        sources: [{
                            locator: new Locator({ url: this.mapConfig.geocode.URL }),
                            singleLineFieldName: this.mapConfig.geocode.fieldName,
                            name: this.mapConfig.geocode.name,
                            localSearchOptions: {
                                distance: 50000
                            },
                            placeholder: "Enter address",
                            maxResults: 3,
                            maxSuggestions: 5,
                            suggestionsEnabled: true,
                            minSuggestCharacters: 2,
                            zoomScale: 4000
                        }],
                        autoSelect: false,
                        popupOpenOnSelect: false,
                        popupEnabled: true
                    });

                    this.search.on("search-complete", this.searchComplete);
                    this.search.on("search-clear", this.searchClear);

                    this.search.view = this.view;
                    this.view.ui.add(this.search, "top-left");
                } // if
                
                this.view.ui.move(["zoom"], "top-right");
                this.view.ui.remove("attribution"); //This is required when using ESRI basemap

                this.view.on("click", this.mapClick);
                // this.view.on("pointer-move", (evt) => console.log(this.view.toMap({x: evt.x, y: evt.y})));
                
                this.view.popup.dockEnabled = this.mapConfig.defaultDocked;
                this.view.popup.dockOptions.position = "bottom-left";
                this.view.popup.dockOptions.breakpoint = false;
                this.view.popup.viewModel.watch("selectedFeature", this.selectedFeatureChange);
                
                var emitValueAction = {
                    id: "emit-value",
                    title: this.mapConfig.emitValueOptions.title,
                    className: this.mapConfig.emitValueOptions.icon
                }
                this.view.popup.actions.push(emitValueAction);
                this.view.popup.on("trigger-action", 
                    (event) => {
                        if (event.action.id === "emit-value") {
                            this.$emit("emit-value", this.selectionData);
                        } // if
                    }
                );
                
                this.sketchViewModel = new SketchViewModel({
                    view: this.view,
                    //layer: this.map.findLayerById("resultsLayer"),
                    polygonSymbol: {
                        type: "simple-fill", // autocasts as new SimpleFillSymbol()
                        color: "rgba(138,43,226, 0.8)",
                        style: "solid",
                        outline: {
                        color: "white",
                        width: 1
                        }
                    }
                });
                
                //The event name is "draw-complete" in API versions 4.7 or less (currently using 4.9)
                this.sketchViewModel.on("create-complete", this.selectFeatures);
                
                if (this.mapConfig.showToolbar) {
                    document.getElementById("rectangleButton").onclick = () => {
                        // set the sketch to create a polygon geometry
                        this.sketchViewModel.create("rectangle");
                        // setActiveButton(this);
                    };

                    document.getElementById("multiselectButton").onclick = () => { this.multiSelect = !this.multiSelect };
                    document.getElementById("clearButton").onclick = this.searchClear;
                } // if

                //Set interval to update live grader/plow tracking
                if (this.mapConfig.live) {
                    this.interval = setInterval(async () => {
                        let { data } = await axios.get(this.mapConfig.proxyURL + this.mapConfig.opendataService.url + this.mapConfig.liveData.query);

                        if (!data.error)
                            this.addLiveMarkers(data);
                        else
                            console.log(data.error);
                    }, 3000);
                } // if
            } // loadMap()
        },
        data() {
            return {
                searchResults: [],
                view: {},
                map: null,
                search: {},
                legend: {},
                identifyResults: {},
                identify: {},
                query: {},
                identifyTask: {},
                queryTask: {},
                sketchViewModel: {},
                multiSelect: false,
                interval: null
            }
        },
        mounted() {
           
        },
        beforeDestroy() {
            //Stop polling for live data
            clearInterval(this.interval);
        },
        watch: {
            checkedLayers: 'setLayers',
            selectedFeature: 'tableSelect',
            updateFeature: 'featureUpdate',
            updateLayer: 'fullLayerUpdate',
            customQuery: 'runCustomQuery',
            configReady: 'loadMap',
            searchValue: 'runSearch',
            resetView: 'defaultView'
        }
    }; //export default
</script>
<style scoped>
    @import url("https://js.arcgis.com/4.9/esri/css/main.css");

    #viewDiv {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        /* border: 4px #35495e solid; */
        /*border: 4px #3a3a3a solid;
        border-radius: 4px;
        margin-bottom: 20px;
        margin-top: 10px;*/
        text-align: left;
    }
    #toolbar {
      background: #fff;
      position: absolute;
      top: 60px;
      left: 15px;
      padding: 10px;
    }
    .action-button {
      font-size: 16px;
      background-color: transparent;
      border: 1px solid #D3D3D3;
      color: #6e6e6e;
      height: 32px;
      width: 32px;
      text-align: center;
      box-shadow: 0 0 1px rgba(0, 0, 0, 0.3);
    }

    .action-button:hover {
      background: #0079c1;
      color: #e4e4e4;
    }

    .action-button-toggle {
      background: #004e7a;
      color: #e4e4e4;
    }

    .active {
      background: #0079c1;
      color: #e4e4e4;
    }
</style>